export default __webpack_public_path__ + "static/SR China - Ingredient & Label - Caramel Colors - Statement-c1da77a3fef885ec4faf775afeff5864.pdf";